import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "react-bootstrap-v5";
import './buttons.scss'

const ButtonIconCancel = ({onClick, selected}) => (
    <Button className={`button-icon-cancel ${selected}`} onClick={onClick}><FontAwesomeIcon icon="times"/></Button>
);

export default ButtonIconCancel;